import { TorchIcon } from './TorchIcon';

/**
 * author: Michael Irigoyen
 * id 5E37234B-E874-4FB7-AC74-BD836129C433
 * name torch
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/torch.svg
 * tags
 * - Sport 
 */
export const OlympicsIcon = TorchIcon;
export default OlympicsIcon